var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.body_class},[_c('div',{class:_vm.main_class},[_c('notifications',{attrs:{"group":"store_notifications","position":"top left","width":"auto","animation-type":"css","speed":600}}),_c('notifications',{attrs:{"group":"toast_top_right","position":"top right","width":"auto","animation-type":"css","speed":600}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }